var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"ShippingMethod__Resume"},[_c('ProductList',{attrs:{"products":_vm.products,"method":_vm.method}}),(_vm.showShippingPrice)?_c('div',{staticClass:"ShippingMethod__Resume__Price"},[_vm._v(" "+_vm._s(_vm.method.shipping_price ? _vm.formatMoney(_vm.method.shipping_price) : 'Grátis')+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }